import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import PropTypes from 'prop-types';
import { PageTitle, H2, PageSubhead, PageActions } from 'next/components/ui';
import { fetchUserProfile } from 'actions/userProfiles';
import { selectAccountUserProfile } from 'reducers/account/userProfiles';
import { selectAccountMeta } from 'reducers/account/meta';
import {
  IdentifierValue,
  IdentifierName,
  IdentifierListItem,
  IdentifiersListSection,
  IdentifierText,
  ProfileHeader,
} from './styled';
import { SelectIdentifierModalManager } from './SelectIdentifierModal/SelectIdentifierModalManager';
import CopyButton from './CopyButton';

export function Header({
  userId,
  onLoad,
  timestamp,
  userProfileIdentifierValue: identifierValue,
}) {
  useEffect(() => {
    onLoad?.(userId);
  }, [onLoad, userId]);

  return (
    <>
      <ProfileHeader>
        <PageTitle>
          <H2 role="heading">
            User profile
            {identifierValue && (
              <IdentifierText title={identifierValue}>
                {' '}
                -{' '}
                {identifierValue?.length > 30
                  ? `${identifierValue.slice(0, 30)}...`
                  : identifierValue}
              </IdentifierText>
            )}
          </H2>
          <SelectIdentifierModalManager />
        </PageTitle>
        <PageActions>
          <CopyButton value={`${window.location.origin}/users/${userId}`} />
        </PageActions>
        <PageSubhead>
          <IdentifiersListSection>
            <IdentifierListItem>
              <IdentifierName>User ID</IdentifierName>
              <IdentifierValue>{userId}</IdentifierValue>
            </IdentifierListItem>

            {timestamp && (
              <IdentifierListItem>
                <IdentifierName>Last seen</IdentifierName>
                <IdentifierValue>{moment(timestamp).fromNow()}</IdentifierValue>
              </IdentifierListItem>
            )}
          </IdentifiersListSection>
        </PageSubhead>
      </ProfileHeader>
    </>
  );
}

Header.propTypes = {
  userId: PropTypes.number,
  timestamp: PropTypes.number,
  userProfileIdentifierValue: PropTypes.string,
  onLoad: PropTypes.func,
};

const mapStateToProps = (state, { userId }) => {
  const userProfileIdentifier = selectAccountMeta(state)?.userProfileIdentifier;
  const userProfile = selectAccountUserProfile(state, userId);

  return {
    userProfileIdentifierValue: userProfileIdentifier
      ? userProfile?.[userProfileIdentifier]
      : null,

    // eslint-disable-next-line no-underscore-dangle
    timestamp: userProfile?._updatedAt,
  };
};

const mapDispatchToProps = {
  onLoad: fetchUserProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Header);
